__turbopack_context__.v({
  "bentoItemStandalone": "MiniPresaleCTA-module__2med8a__bentoItemStandalone",
  "buttonGlow": "MiniPresaleCTA-module__2med8a__buttonGlow",
  "buyButton": "MiniPresaleCTA-module__2med8a__buyButton",
  "content": "MiniPresaleCTA-module__2med8a__content",
  "errorContainer": "MiniPresaleCTA-module__2med8a__errorContainer",
  "errorMessage": "MiniPresaleCTA-module__2med8a__errorMessage",
  "header": "MiniPresaleCTA-module__2med8a__header",
  "icon": "MiniPresaleCTA-module__2med8a__icon",
  "info": "MiniPresaleCTA-module__2med8a__info",
  "loadingContainer": "MiniPresaleCTA-module__2med8a__loadingContainer",
  "loadingSpinner": "MiniPresaleCTA-module__2med8a__loadingSpinner",
  "miniPresaleCta": "MiniPresaleCTA-module__2med8a__miniPresaleCta",
  "price": "MiniPresaleCTA-module__2med8a__price",
  "spin": "MiniPresaleCTA-module__2med8a__spin",
  "title": "MiniPresaleCTA-module__2med8a__title",
});
